'use strict';

class AlertsPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    let initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getCallCenterAlerts(startDate, endDate)
        .then((reportInfo) => {

          let callCenterAlerts;
          let callCenterDispatchEvents;

          if (!reportInfo || !reportInfo.executions || reportInfo.executions.length <= 0) {
            callCenterAlerts = [];
            callCenterDispatchEvents = [];
          } else {
            let executions = reportInfo.executions
              .slice()
              .sort((a, b) => a.executionDateMs - b.executionDateMs); // latest last

            if (initial) {
              getLastMeasurement(executions[executions.length - 1]);
              initial = false;
            }

            callCenterAlerts = executions
              .map(execution => ({
                x: execution.executionDateMs,
                y: execution.data?.find(d => d.id === 3)?.value
              }));

            callCenterDispatchEvents = executions
              .map(execution => ({
                x: execution.executionDateMs,
                y: execution.data?.find(d => d.id === 6)?.value
              }));
          }

          return [
            {
              data: callCenterDispatchEvents,
              label: $t('dash.panel.reports.alerts.callCenterDispatchEvents')
            },
            {
              data: callCenterAlerts,
              label: $t('dash.panel.reports.alerts.callCenterAlerts')
            }
          ];
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(executions) {
      if (!executions) {
        return;
      }

      let info = [];
      info.push({
        icon: 'clock',
        name: $t('dash.panel.reports.lastMeasured'),
        value: $filter('date')(executions.executionDateMs, currentDateFormat)
      });

      const dictionaryHelper = [
        {
          id: 1,
          name: $t('dash.panel.reports.alerts.monthlyCallCenterAlerts'),
          icon: 'phone'
        },
        {
          id: 2,
          name: $t('dash.panel.reports.alerts.weeklyCallCenterAlerts'),
          icon: 'phone'
        }
      ];

      // Get total except "no subscriptions"
      for (let [key, value] of Object.entries(executions.data || {})) {
        let helper = dictionaryHelper.find(el => el.id === value.id);
        if (helper) {
          info.push({
            icon: helper.icon,
            name: helper.name + ' -',
            value: value.value
          });
        }
      }

      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.alertsPage.controller', [])
  .controller('AlertsPageController', AlertsPageController)
  .name;
